import cssImports from './imports.json' with { type: 'json' };
import { defaultBase } from './links/constants';
import { createFilter } from './links/create-filter';
import { getMediaQuery } from './links/get-media-query';
import type { LinkProps, LinkPropsList, LinksFunction } from './links/types';

export const links: LinksFunction = ({ base = defaultBase, filter } = {}) => {
  const baseHref = typeof base === 'string' ? base : base?.href;
  const normalizedBase =
    baseHref && !baseHref.endsWith('/') ? `${baseHref}/` : baseHref;
  const linkProps: LinkPropsList = Object.entries(cssImports)
    .filter(createFilter(filter))
    .map(([name, filename]) => {
      const props: LinkProps = {
        rel: 'stylesheet',
        href: normalizedBase + filename,
        'data-volvo-css-name': name,
        crossOrigin: 'anonymous',
      };
      const media = getMediaQuery(name);
      if (media) {
        props.media = media;
      }
      return props;
    });
  linkProps.toString = function () {
    let html = '';
    for (const link of this) {
      const attrs = Object.entries(link)
        .map(([key, value]) => `${key}="${value}"`)
        .join(' ');
      html += `<link ${attrs} />\n`;
    }
    return html;
  };
  return linkProps;
};

export type { LinkProps, LinksFunction };
